import React, { useEffect, useState, useRef, useMemo } from 'react';
import { ConnectWebSocketForOverlay, DisconnectWebSocket, SetSocketMessageHandler, ClearSocketMessageHandler } from './../../../utilities/BL/Zones';
import { GetRouletteConfig } from './../../../utilities/BL/Roulette';

const Roulette = ({ screenId = 1, isStandalone = true, payload = null }) => {
    const [prizes, setPrizes] = useState([]);
    const [spinDuration, setSpinDuration] = useState(5000);
    const [scale, setScale] = useState(100);
    const [rotation, setRotation] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);
    const [winnerData, setWinnerData] = useState(null);

    const rouletteRef = useRef(null);

    // Cargar la configuración visual desde la base de datos
    const fetchConfig = async () => {
        const res = await GetRouletteConfig(screenId);
        if (res && res.success && res.data) {
            setPrizes(res.data.prizes || []);
            setSpinDuration(res.data.spinDurationMs || 5000);
            setScale(res.data.scale || 100);
        }
    };

    useEffect(() => {
        fetchConfig();

        if (!isStandalone) return;

        const connectWS = async () => {
            const overlayType = `roulette:screen:${screenId}`;
            await ConnectWebSocketForOverlay(overlayType, () => {}, (msg) => console.log(msg));
            SetSocketMessageHandler(handleIncomingMessage);
        };

        connectWS();

        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screenId, isStandalone]);

    // Escuchar órdenes si viene incrustado en el Canvas general del Estadio
    useEffect(() => {
        if (!isStandalone && payload) handleIncomingMessage(payload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payload, isStandalone]);

    const handleIncomingMessage = (message) => {
        if (!message || !message.type) return;

        switch (message.type.toLowerCase()) {
            case 'roulette.prepare':
                fetchConfig();
                resetRoulette();
                break;
            case 'roulette.spin':
                executeSpinAnimation(message.payload || message.data);
                break;
            default:
                break;
        }
    };

    const resetRoulette = () => {
        setRotation(0);
        setIsSpinning(false);
        setWinnerData(null);
        //setStatusMessage('¡LISTO PARA GIRAR!');
    };

    // Lógica de giro (Asegura siempre dirección horaria y detención exacta)
    const executeSpinAnimation = (spinData) => {
        if (isSpinning) return;
        
        const { prizeWon, spinDurationMs } = spinData;
        setIsSpinning(true);
        //setStatusMessage('¡GIRANDO!');
        setWinnerData(null);

        const targetIndex = prizes.findIndex(p => p.text === prizeWon);
        if (targetIndex === -1) {
            setIsSpinning(false);
            return;
        }

        const sliceSize = 360 / prizes.length;
        
        // Calculamos el ángulo para que el puntero (las 12) quede en el centro de la rebanada
        // Usamos rotación acumulativa para que siempre gire en sentido horario
        const offset = (targetIndex * sliceSize) + (sliceSize / 2);
        const newRotation = rotation + (5 * 360) + (360 - offset - rotation % 360);

        setRotation(newRotation);

        setTimeout(() => {
            setIsSpinning(false);
            setWinnerData({ prizeWon });
        }, spinDurationMs);
    };

    // Construcción del degradado cónico CSS dinámico basado en las rebanadas del Admin
    const wheelStyle = useMemo(() => {
        if (!prizes.length) return {};
        const slicePercent = 100 / prizes.length;
        let gradientParts = [];
        
        prizes.forEach((prize, index) => {
            // Patrón Rojo (#1e246a) y Negro (#000000)
            const color = (index % 2 === 0) ? '#1e246a' : '#fff';  //'#000000'; 
            const start = (index * slicePercent) + 0.2; 
            const end = ((index + 1) * slicePercent) - 0.2;
            gradientParts.push(`${color} ${start}% ${end}%`);
        });

        return {
            background: `conic-gradient(from 0deg, ${gradientParts.join(', ')})`,
            backgroundColor: '#000',
            transform: `rotate(${rotation}deg)`,
            transition: isSpinning ? `transform ${spinDuration}ms cubic-bezier(0.2, 0, 0.2, 1)` : 'none',
            border: '10px solid #fff'
        };
    }, [prizes, rotation, isSpinning, spinDuration]);

    return (
        <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden', backgroundColor: '#111', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            
            {/* IMAGEN DE FONDO */}
            <div className='SelfieFan__Screen__QR__Background'>
                <img 
                    //src='/img/page/backgrounds/background.png' // Varonil
                    src='/img/selfiefan/Fondo-SelfieFan-Femenil.png'
                    className='SelfieFan__Screen__QR__Background__Video'
                    alt="Background"
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                />
            </div>

            {/* TEXTOS SUPERIORES */}
            <div style={{ position: 'absolute', top: '2%', left: '1%', zIndex: 10, textAlign: 'center', color: 'white' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fff', color: '#1e246a', padding: '10px 40px', borderRadius: '10px', boxShadow: '0 10px 25px rgba(0,0,0,0.5)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <h1 style={{ fontSize: '2.4rem', fontWeight: '900', textTransform: 'uppercase', marginBottom: '0', letterSpacing: '2px', color: '#1e246a' }}>Ruleta de la fortuna</h1>
                    </div>
                    <div className='d-flex align-items-center' style={{ marginTop: '5px' }}>
                        <span className='text-dark' style={{ fontWeight: '500' }}>Hecho con ♥ por </span>
                        <img src="/img/page/adsl-five-bicolor.png" alt="ADSL Logo" style={{ maxWidth: '180px', marginLeft: '8px' }} />
                    </div>
                </div>
            </div>

            {/* CONTENEDOR PRINCIPAL CON ESCALA */}
            <div style={{ transform: `scale(${scale / 100})`, position: 'relative', width: '600px', height: '600px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0px' }}>
                
                {/* PUNTERO DE SELECCIÓN */}
                <div style={{ position: 'absolute', top: '-140px', zIndex: 100, width: '0', height: '0', borderLeft: '70px solid transparent', borderRight: '70px solid transparent', borderTop: '90px solid #fff', filter: 'drop-shadow(0px 4px 10px rgba(0,0,0,0.7))' }} />

                {/* CUERPO DE LA RULETA */}
                <div ref={rouletteRef} style={{ ...wheelStyle, position: 'absolute', width: '850px', height: '850px', borderRadius: '50%', border: '15px solid #111', boxShadow: '0 0 80px rgba(0,0,0,1)', overflow: 'hidden' }}> {/* rgba(220,38,38,0.8) */}
                    {prizes.map((prize, idx) => {
                        const angle = (360 / prizes.length) * idx + (360 / prizes.length) / 2;
                        return (
                            <div key={prize.id || idx} style={{ 
                                position: 'absolute', 
                                width: '45%', 
                                height: '100px', 
                                top: 'calc(50% - 50px)', 
                                left: '50%', 
                                transformOrigin: '0% 50%', 
                                transform: `rotate(${angle - 90}deg) translateX(70px)`, 
                                display: 'flex', 
                                flexDirection: 'column', 
                                justifyContent: 'center', 
                                alignItems: 'flex-start',  
                                fontWeight: 'bold', 
                                fontSize: '1.8rem', 
                                paddingLeft: '10px', 
                                lineHeight: '1.2', 
                                textAlign: 'left',
                                wordWrap: 'break-word',
                                pointerEvents: 'none'
                            }}>
                                <span style={{ color: idx % 2 === 0 ? '#fff' : '#000' }}>{prize.text}</span>
                            </div>
                        );
                    })}
                </div>

                {/* CENTRO DE LA RULETA */}
                <div style={{ position: 'absolute', width: '90px', height: '90px', backgroundColor: '#222', borderRadius: '50%', border: '6px solid #1e246a', boxShadow: 'inset 0 0 15px rgba(255,255,255,0.2), 0 4px 15px rgba(0,0,0,0.6)', zIndex: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '40px', height: '40px', backgroundColor: '#ffffff', borderRadius: '50%' }} />
                </div>
            </div>

            {/* POPUP DE GANADOR */}
            {winnerData && (
                <div style={{ position: 'absolute', bottom: '10%', width: '100%', textAlign: 'center', zIndex: 200 }}>
                    <div style={{ display: 'inline-block', padding: '20px 50px', backgroundColor: 'rgba(0,0,0,0.9)', border: '4px solid #1e246a', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
                        <p style={{ fontSize: '3rem', fontWeight: '900', color: 'white', margin: 0, textTransform: 'uppercase', letterSpacing: '1px' }}>{winnerData.prizeWon}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export { Roulette };
